import {useIntl, FormattedMessage} from 'react-intl'
import {Link} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../_gori/helpers'
import {StartFreeToday} from './components/StartFreeToday'
import {PublicWrapper} from '../../modules/common/components/PublicWrapper'
import {ROUTES} from '../../../_gori/constants'
import {GoriBlog} from '../../modules/help-center/components/common/GoriBlog'
import clsx from 'clsx'
import {Carousel} from 'react-bootstrap'

export function BaeGuardPage() {
  const intl = useIntl()

  const carouselItems = [
    {
      image: '/media/gori/baeguard/enable-at-checkout-graphic.webp',
      titleId: 'BAEGUARD_HOW_IT_WORKS_CAROUSEL_ITEM_1_TITLE',
      descriptionId: 'BAEGUARD_HOW_IT_WORKS_CAROUSEL_ITEM_1_DESCRIPTION',
      alt: 'Enable Protection at Checkout',
      helpCenterLink: '/help-center/baeguard/manual-insurance',
    },
    // {
    //   image: '/media/gori/baeguard/automatic-protection-graphic.webp',
    //   titleId: 'BAEGUARD_HOW_IT_WORKS_CAROUSEL_ITEM_2_TITLE',
    //   descriptionId: 'BAEGUARD_HOW_IT_WORKS_CAROUSEL_ITEM_2_DESCRIPTION',
    //   alt: 'Automatic Protection',
    // },
    {
      image: '/media/gori/baeguard/fast-claims-process-graphic.webp',
      titleId: 'BAEGUARD_HOW_IT_WORKS_CAROUSEL_ITEM_3_TITLE',
      descriptionId: 'BAEGUARD_HOW_IT_WORKS_CAROUSEL_ITEM_3_DESCRIPTION',
      alt: 'Fast Claims Process',
      helpCenterLink: '/help-center/manage-shipment/create-claims',
    },
  ]

  return (
    <>
      <PublicWrapper>
        <div className='baeguard-page-container'>
          <section className='hero py-100px'>
            <img
              src={toAbsoluteUrl('/media/logos/baeguard-logo.svg')}
              alt='BaeGuard'
              className='baeguard-logo d-block mx-auto mb-6'
            />
            <p
              className='text-center text-gray-700 fw-bold mb-6'
              dangerouslySetInnerHTML={{
                __html: intl.formatMessage({id: 'BAEGUARD_SUBTITLE'}),
              }}
            ></p>
            <Link
              to={ROUTES.AUTH.REGISTRATION}
              className='btn btn-outline btn-primary-deep hover-orange rounded-pill text-center d-block w-fit-content mx-auto mb-12px'
            >
              {intl.formatMessage({id: 'BAEGUARD_ACTIVATE_BAEGUARD'})}
            </Link>
          </section>

          <section className='rising-threat bg-white py-100px'>
            <div className='container'>
              <h2 className='text-center raleway mb-4'>
                {intl.formatMessage({id: 'BAEGUARD_RISING_THREAT_TITLE'})}
              </h2>

              <p className='text-center poppins fw-bold'>
                {intl.formatMessage({id: 'BAEGUARD_RISING_THREAT_SUBTITLE'})}
              </p>

              <img
                className='threat-stats d-block mx-auto mw-100'
                src={toAbsoluteUrl('/media/gori/baeguard/shipping-loss-map.webp')}
                alt='Shipping Loss Map'
              />

              <h2 className='text-center raleway mb-4'>
                {intl.formatMessage({id: 'BAEGUARD_SHIPPING_LOSSES_MATTER_TITLE'})}
              </h2>

              <p className='text-center poppins fw-bold pb-0'>
                {intl.formatMessage({id: 'BAEGUARD_SHIPPING_LOSSES_MATTER_SUBTITLE'})}
              </p>

              <div className='d-flex flex-column flex-md-row flex-wrap justify-content-center align-items-center gap-6'>
                <div className='matter-item text-center'>
                  <h3>{intl.formatMessage({id: 'BAEGUARD_MATTER_1_TITLE'})}</h3>
                  <p>{intl.formatMessage({id: 'BAEGUARD_MATTER_1_SUBTITLE'})}</p>
                </div>
                <div className='matter-item text-center'>
                  <h3>{intl.formatMessage({id: 'BAEGUARD_MATTER_2_TITLE'})}</h3>
                  <p>{intl.formatMessage({id: 'BAEGUARD_MATTER_2_SUBTITLE'})}</p>
                </div>
                <div className='matter-item text-center'>
                  <h3>{intl.formatMessage({id: 'BAEGUARD_MATTER_3_TITLE'})}</h3>
                  <p>{intl.formatMessage({id: 'BAEGUARD_MATTER_3_SUBTITLE'})}</p>
                </div>
              </div>
            </div>
          </section>

          <section className='carrier-comparison py-100px'>
            <div className='container'>
              <h2 className='text-center raleway mb-20'>
                {intl.formatMessage({id: 'BAEGUARD_CARRIER_COMPARISON_TITLE'})}
              </h2>
              <div className='comparison-table-wrapper mb-20'>
                <table className='baeguard-table d-none d-xl-table'>
                  <thead>
                    <tr>
                      <th>{intl.formatMessage({id: 'BAEGUARD_COMPARISON_FEATURE'})}</th>
                      <th>{intl.formatMessage({id: 'BAEGUARD_COMPARISON_STANDARD'})}</th>
                      <th className='baeguard-col-header'>
                        {intl.formatMessage({id: 'BAEGUARD_COMPARISON_BAEGUARD'})}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        {intl.formatMessage({id: 'BAEGUARD_COMPARISON_COST'})}
                        {` `}
                        <sub>{intl.formatMessage({id: 'BAEGUARD_COMPARISON_COST_SUB'})}</sub>
                      </td>
                      <td>{intl.formatMessage({id: 'BAEGUARD_COMPARISON_COST_STANDARD'})}</td>
                      <td>
                        {intl.formatMessage({id: 'BAEGUARD_COMPARISON_COST_BAEGUARD'})}&nbsp;
                        <div className='savings-badge'>
                          <p>
                            {intl.formatMessage({id: 'BAEGUARD_COMPARISON_COST_BAEGUARD_BADGE'})}
                          </p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>{intl.formatMessage({id: 'BAEGUARD_COMPARISON_CLAIMS'})}</td>
                      <td>{intl.formatMessage({id: 'BAEGUARD_COMPARISON_CLAIMS_STANDARD'})}</td>
                      <td>{intl.formatMessage({id: 'BAEGUARD_COMPARISON_CLAIMS_BAEGUARD'})}</td>
                    </tr>
                    <tr>
                      <td>{intl.formatMessage({id: 'BAEGUARD_COMPARISON_COVERAGE'})}</td>
                      <td>{intl.formatMessage({id: 'BAEGUARD_COMPARISON_COVERAGE_STANDARD'})}</td>
                      <td>
                        {intl.formatMessage({id: 'BAEGUARD_COMPARISON_COVERAGE_BAEGUARD'})}&nbsp;
                        <Link to='/help-center/baeguard/coverage'>
                          {intl.formatMessage({
                            id: 'BAEGUARD_COMPARISON_COVERAGE_BAEGUARD_DETAILS',
                          })}
                        </Link>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div className='baeguard-cards d-xl-none'>
                  <div className='comparison-card'>
                    <h3 className='card-title'>
                      {intl.formatMessage({id: 'BAEGUARD_COMPARISON_COST'})}
                      <br />
                      <span className='card-subtitle'>
                        {intl.formatMessage({id: 'BAEGUARD_COMPARISON_COST_SUB'})}
                      </span>
                    </h3>
                    <div className='card-section'>
                      <p className='section-label'>
                        {intl.formatMessage({id: 'BAEGUARD_COMPARISON_STANDARD'})}
                      </p>
                      <p className='section-value'>
                        {intl.formatMessage({id: 'BAEGUARD_COMPARISON_COST_STANDARD'})}
                      </p>
                    </div>
                    <div className='card-section baeguard-section'>
                      <p className='section-label'>
                        {intl.formatMessage({id: 'BAEGUARD_COMPARISON_BAEGUARD'})}
                      </p>
                      <p className='section-value'>
                        {intl.formatMessage({id: 'BAEGUARD_COMPARISON_COST_BAEGUARD'})}
                      </p>
                      <div className='savings-badge'>
                        <p>{intl.formatMessage({id: 'BAEGUARD_COMPARISON_COST_BAEGUARD_BADGE'})}</p>
                      </div>
                    </div>
                  </div>

                  <div className='comparison-card'>
                    <h3 className='card-title'>
                      {intl.formatMessage({id: 'BAEGUARD_COMPARISON_CLAIMS'})}
                    </h3>
                    <div className='card-section'>
                      <p className='section-label'>
                        {intl.formatMessage({id: 'BAEGUARD_COMPARISON_STANDARD'})}
                      </p>
                      <p className='section-value'>
                        {intl.formatMessage({id: 'BAEGUARD_COMPARISON_CLAIMS_STANDARD'})}
                      </p>
                    </div>
                    <div className='card-section baeguard-section'>
                      <p className='section-label'>
                        {intl.formatMessage({id: 'BAEGUARD_COMPARISON_BAEGUARD'})}
                      </p>
                      <p className='section-value'>
                        {intl.formatMessage({id: 'BAEGUARD_COMPARISON_CLAIMS_BAEGUARD'})}
                      </p>
                    </div>
                  </div>

                  <div className='comparison-card'>
                    <h3 className='card-title'>
                      {intl.formatMessage({id: 'BAEGUARD_COMPARISON_COVERAGE'})}
                    </h3>
                    <div className='card-section'>
                      <p className='section-label'>
                        {intl.formatMessage({id: 'BAEGUARD_COMPARISON_STANDARD'})}
                      </p>
                      <p className='section-value'>
                        {intl.formatMessage({id: 'BAEGUARD_COMPARISON_COVERAGE_STANDARD'})}
                      </p>
                    </div>
                    <div className='card-section baeguard-section'>
                      <p className='section-label'>
                        {intl.formatMessage({id: 'BAEGUARD_COMPARISON_BAEGUARD'})}
                      </p>
                      <p className='section-value'>
                        {intl.formatMessage({id: 'BAEGUARD_COMPARISON_COVERAGE_BAEGUARD'})}
                      </p>
                      <Link to='/help-center/baeguard/coverage'>
                        {intl.formatMessage({id: 'BAEGUARD_COMPARISON_COVERAGE_BAEGUARD_DETAILS'})}
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <Link
                to={ROUTES.AUTH.REGISTRATION}
                className='btn btn-outline btn-primary-deep hover-orange rounded-pill text-center d-block w-fit-content mx-auto mb-12px'
              >
                {intl.formatMessage({id: 'BAEGUARD_ACTIVATE_BAEGUARD'})}
              </Link>
            </div>
          </section>

          <section className='why-baeguard bg-white py-80px'>
            <div className='container'>
              <h2 className='text-center raleway mb-4'>
                {intl.formatMessage({id: 'BAEGUARD_WHY_BAEGUARD_TITLE'})}
              </h2>
              <p className='text-center poppins mb-15'>
                {intl.formatMessage({id: 'BAEGUARD_WHY_BAEGUARD_SUBTITLE'})}
              </p>
              <div className='d-flex flex-column flex-md-row justify-content-center align-items-stretch gap-7'>
                <div className='why-item'>
                  <img
                    src={toAbsoluteUrl('/media/gori/baeguard/full-value-protection.svg')}
                    alt='Full Value Protection'
                    className='mb-4'
                  />
                  <h3>{intl.formatMessage({id: 'BAEGUARD_WHY_1_TITLE'})}</h3>
                  <p>{intl.formatMessage({id: 'BAEGUARD_WHY_1_DESCRIPTION'})}</p>
                </div>
                <div className='why-item'>
                  <img
                    src={toAbsoluteUrl('/media/gori/baeguard/cost-savings.svg')}
                    alt='Cost Savings'
                    className='mb-4'
                  />
                  <h3>{intl.formatMessage({id: 'BAEGUARD_WHY_2_TITLE'})}</h3>
                  <p>{intl.formatMessage({id: 'BAEGUARD_WHY_2_DESCRIPTION'})}</p>
                </div>
                <div className='why-item'>
                  <img
                    src={toAbsoluteUrl('/media/gori/baeguard/fast-claims.svg')}
                    alt='Fast Claims'
                    className='mb-4'
                  />
                  <h3>{intl.formatMessage({id: 'BAEGUARD_WHY_3_TITLE'})}</h3>
                  <p>{intl.formatMessage({id: 'BAEGUARD_WHY_3_DESCRIPTION'})}</p>
                </div>
                <div className='why-item'>
                  <img
                    src={toAbsoluteUrl('/media/gori/baeguard/multi-carrier.svg')}
                    alt='Multi-Carrier Coverage'
                    className='mb-4'
                  />
                  <h3>{intl.formatMessage({id: 'BAEGUARD_WHY_4_TITLE'})}</h3>
                  <p>{intl.formatMessage({id: 'BAEGUARD_WHY_4_DESCRIPTION'})}</p>
                </div>
              </div>
            </div>
          </section>

          <section className='how-it-works py-80px'>
            <div className='container'>
              <h2 className='text-center raleway mb-15'>
                {intl.formatMessage({id: 'BAEGUARD_HOW_IT_WORKS_TITLE'})}
              </h2>
              <Carousel className='mb-19' interval={3000} touch={true} indicators>
                {carouselItems.map((item, index) => (
                  <Carousel.Item key={index}>
                    <div className='d-flex flex-column flex-lg-row justify-content-center align-items-center gap-20'>
                      <img
                        src={toAbsoluteUrl(item.image)}
                        alt={item.alt}
                        className='how-it-works-img'
                      />
                      <div>
                        <h3 className='mb-4'>{intl.formatMessage({id: item.titleId})}</h3>
                        <p className='mb-4'>
                          <FormattedMessage
                            id={item.descriptionId}
                            values={{
                              br: <br />,
                              helpCenterLink: (chunks: React.ReactNode) =>
                                item.helpCenterLink ? (
                                  <Link
                                    to={item.helpCenterLink}
                                    target='_self'
                                    rel='noreferrer'
                                    className='p-0 btn-advanced-editorial fs-inherit'
                                  >
                                    {chunks}
                                  </Link>
                                ) : (
                                  chunks
                                ),
                            }}
                          />
                        </p>
                      </div>
                    </div>
                  </Carousel.Item>
                ))}
              </Carousel>

              <p className='footnote text-center'>
                {intl.formatMessage({id: 'BAEGUARD_HOW_IT_WORKS_FOOTNOTE'})}
              </p>
              <Link
                to={ROUTES.AUTH.REGISTRATION}
                className='btn btn-outline btn-primary-deep hover-orange rounded-pill text-center d-block w-fit-content mx-auto mt-12 mb-12px'
              >
                {intl.formatMessage({id: 'BAEGUARD_ACTIVATE_BAEGUARD'})}
              </Link>
            </div>
          </section>

          <section className='baeguard-blog bg-white py-80px'>
            <div className='container'>
              <h2 className='text-center raleway mb-15'>
                {intl.formatMessage({id: 'BAEGUARD_LEARN_MORE_TITLE'})}
              </h2>
              <GoriBlog slug='q4-shipping-insurance-for-small-businesses' />
              <Link
                className={clsx(
                  'btn-color btn btn-outline btn-primary hover-orange rounded-pill text-center d-block w-fit-content custom-button btn-temu-orange mx-auto mt-18 mb-2'
                )}
                to='/help-center/baeguard'
              >
                {intl.formatMessage({id: 'BAEGUARD_GO_TO_HELP_CENTER'})}
              </Link>
            </div>
          </section>

          <StartFreeToday />
        </div>
      </PublicWrapper>
    </>
  )
}
